module.exports = __webpack_public_path__ + "files/d6276a6639f79f6d61542ffcb015d51f.png";